"use client";

import React from "react";

import Image, { type StaticImageData } from "next/image";

import { AccordionTrigger } from "@repo/ui/components/ui/accordion";

// Small helper to render the repeated trigger layout for each section
const SectionTrigger: React.FC<{
  icon: StaticImageData | string;
  iconWidth: number;
  iconHeight: number;
  title: React.ReactNode;
  amountText?: string | React.ReactNode;
  iconAlt: string;
  testId?: string;
}> = ({
  icon,
  iconWidth,
  iconHeight,
  title,
  amountText,
  iconAlt,
  testId = "subsection-trigger-btn",
}) => (
  <AccordionTrigger
    className="[&>svg:first-of-type]:text-brand-cyan cursor-pointer items-center gap-1 px-3 py-2.5 hover:!no-underline [&>svg:first-of-type]:h-5 [&>svg:first-of-type]:w-5"
    data-testid={testId}
  >
    <div className="flex flex-wrap items-center justify-between w-full gap-4">
      <div className="flex items-center gap-2 text-sm">
        <Image src={icon} width={iconWidth} height={iconHeight} className="mr-1" alt={iconAlt} />
        <span className="font-semibold text-brand-blue" data-testid={`${testId}-title-lbl`}>
          {title}
        </span>
      </div>
      <div className="text-sm font-semibold text-brand-cyan" data-testid={`${testId}-amount-lbl`}>
        {amountText}
      </div>
    </div>
  </AccordionTrigger>
);
export { SectionTrigger };
